import SimpleLink from 'core/components/SimpleLink'
import Text from 'core/elements/Text'
import { routeManager } from 'core/utils/routes'
import React from 'react'
import { useSelector } from 'react-redux'
import { volumesByIdSelector } from '../selectors'
import { IVolumeDetailsPageTabs } from './model'

type ResourceLinkWithTooltipProps = {
  label: string
  src: string
  children: React.ReactNode
}

export const ResourceLinkWithTooltip: React.FC<ResourceLinkWithTooltipProps> = ({
  label,
  src,
  children,
}) => (
  <Text variant="caption1">
    {label} <SimpleLink src={src}>{children}</SimpleLink>
  </Text>
)

type VolumeSourceCellProps = {
  item: any
}

export const VolumeSourceCell: React.FC<VolumeSourceCellProps> = ({ item }) => {
  const volumesById = useSelector(volumesByIdSelector)
  const sourceVolume = item?.source_volid
  const sourceSnapshot = item?.sourceSnapshot
  const sourceImage = item?.volume_image_metadata

  if (sourceVolume) {
    const volume = volumesById[sourceVolume]
    const volumeNameOrId = volume?.name || volume?.id || sourceVolume
    return (
      <ResourceLinkWithTooltip
        label="Volume:"
        src={routeManager.routes.openstack.volumeDetails.path({
          id: volume?.id || sourceVolume,
          tab: IVolumeDetailsPageTabs.Overview,
        })}
      >
        {volumeNameOrId}
      </ResourceLinkWithTooltip>
    )
  }

  if (sourceSnapshot || item?.snapshot_id) {
    const snapshotNameOrId = sourceSnapshot?.name || sourceSnapshot?.id || item?.snapshot_id
    return (
      <ResourceLinkWithTooltip
        label="Volume Snapshot:"
        src={routeManager.routes.openstack.volumeSnapshots.path()}
      >
        {snapshotNameOrId}
      </ResourceLinkWithTooltip>
    )
  }

  if (sourceImage?.image_name || sourceImage?.image_id) {
    const imageNameOrId = sourceImage?.image_name || sourceImage?.image_id
    return (
      <ResourceLinkWithTooltip label="Image:" src={routeManager.routes.openstack.images.path()}>
        {imageNameOrId}
      </ResourceLinkWithTooltip>
    )
  }

  return null
}
